export const PLAYER = {
  name: 'Player',
  stats: {},
  resources: {
    energy: 3,
    currency: 1000,
    premiumCurrency: 100
  },
  currentCampaignNode: 'level1'
};
